import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { AssetErrorComponent } from '@components/asset/asset-error/asset-error.component';
import { AudioAsset } from '@models/Sessions/Idea/AudioProject';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';

import { AudioAssetResourceComponent } from '../audio-asset-resource/audio-asset-resource.component';

@Component({
  selector: 'app-audio-asset',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MessageModule,
    ButtonModule,
    AssetErrorComponent,
    AudioAssetResourceComponent,
  ],
  templateUrl: './audio-asset.component.html',
  styleUrl: './audio-asset.component.scss',
})
export class AudioAssetComponent {
  @Input() asset: FormControl<AudioAsset>;
}
